import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=f6ff7c40&scoped=true"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"
import style0 from "./Topic.vue?vue&type=style&index=0&id=f6ff7c40&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ff7c40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6ff7c40')) {
      api.createRecord('f6ff7c40', component.options)
    } else {
      api.reload('f6ff7c40', component.options)
    }
    module.hot.accept("./Topic.vue?vue&type=template&id=f6ff7c40&scoped=true", function () {
      api.rerender('f6ff7c40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workBench/components/Topic.vue"
export default component.exports